var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 214,
    viewBox: "0 0 412 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2755_30560)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 190,
    height: 190,
    rx: 12,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3022 158.677H51.7091L53.4899 154.454H46.3022V151.529H54.7308L56.6405 147.017L56.6566 146.977H41V166.3H56.6808V161.739H46.3022V158.677Z",
    fill: "#090A0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.829 148.781C113.387 147.581 111.429 146.976 108.963 146.976H100.68V166.299H106.03V160.78H108.681C111.163 160.78 113.17 160.175 114.701 158.959C116.224 157.742 116.989 156.033 116.989 153.826C116.997 151.666 116.272 149.99 114.829 148.781ZM110.825 155.888C110.285 156.348 109.527 156.581 108.577 156.581H106.038V151.473H108.552C109.527 151.473 110.285 151.69 110.833 152.117C111.373 152.552 111.647 153.181 111.647 154.011C111.639 154.809 111.365 155.429 110.825 155.888Z",
    fill: "#090A0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.21 146.976H118.852V166.299H130.705L132.687 161.602H124.21V146.976Z",
    fill: "#090A0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.805 146.839L134.892 163.189L133.578 166.299H135.383H139.211L140.589 162.851H148.042L149.452 166.299H155.198L146.97 146.839H141.805ZM142.16 158.676L144.344 153.181L146.495 158.676H142.16Z",
    fill: "#090A0B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.015 146.976L162.01 154.011L158.037 146.976H151.938L159.278 159.063V166.299H164.661V158.983L172.002 146.976H166.015Z",
    fill: "#090A0B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5317 146.976L69.1482 159.2L64.7566 146.976H58.7695L66.6099 166.436H71.5737L79.4141 146.976H73.5317Z",
    fill: "#090A0B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4582 146.638C82.9143 146.638 78.418 151.134 78.418 156.678C78.418 162.222 82.9143 166.718 88.4582 166.718C94.0021 166.718 98.4984 162.222 98.4984 156.678C98.4984 151.134 94.0101 146.638 88.4582 146.638ZM88.4582 161.94C85.5493 161.94 83.1883 159.579 83.1883 156.67C83.1883 153.761 85.5493 151.4 88.4582 151.4C91.3671 151.4 93.7281 153.761 93.7281 156.67C93.7281 159.579 91.3671 161.94 88.4582 161.94Z",
    fill: "#090A0B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0781 126.912H118.342L126.451 107.6H62.0781V126.912Z",
    fill: "#0099FA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62 103.743L131.442 94.1746L139.936 73.4669L62 84.3488V103.743Z",
    fill: "#0099FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80.5376L146.328 59.0769L155.832 36L62 60.5186V80.5376Z",
    fill: "#0099FA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M383 6H400C406.627 6 412 11.3726 412 18V35H383V6Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M400 6H234C227.373 6 222 11.3726 222 18V184C222 190.627 227.373 196 234 196H400C406.627 196 412 190.627 412 184V18C412 11.3726 406.627 6 400 6Z",
    fill: "#050000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M257.302 157.606H262.709L264.49 153.384H257.302V150.459H265.731L267.641 145.946L267.657 145.906H252V165.229H267.681V160.668H257.302V157.606Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M325.829 147.71C324.387 146.51 322.429 145.906 319.963 145.906H311.68V165.229H317.03V159.709H319.681C322.163 159.709 324.17 159.104 325.701 157.888C327.224 156.671 327.989 154.963 327.989 152.755C327.997 150.595 327.272 148.919 325.829 147.71ZM321.825 154.818C321.285 155.277 320.527 155.511 319.577 155.511H317.038V150.402H319.552C320.527 150.402 321.285 150.619 321.833 151.047C322.373 151.482 322.647 152.11 322.647 152.94C322.639 153.738 322.365 154.358 321.825 154.818Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M335.21 145.906H329.852V165.229H341.705L343.687 160.531H335.21V145.906Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M352.805 145.768L345.892 162.118L344.578 165.229H346.383H350.211L351.589 161.78H359.042L360.452 165.229H366.198L357.97 145.768H352.805ZM353.16 157.606L355.344 152.11L357.495 157.606H353.16Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M377.015 145.906L373.01 152.94L369.037 145.906H362.938L370.278 157.992V165.229H375.661V157.912L383.002 145.906H377.015Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M284.532 145.906L280.148 158.129L275.757 145.906H269.77L277.61 165.366H282.574L290.414 145.906H284.532Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M299.458 145.567C293.914 145.567 289.418 150.063 289.418 155.607C289.418 161.151 293.914 165.647 299.458 165.647C305.002 165.647 309.498 161.151 309.498 155.607C309.498 150.063 305.01 145.567 299.458 145.567ZM299.458 160.869C296.549 160.869 294.188 158.508 294.188 155.599C294.188 152.69 296.549 150.329 299.458 150.329C302.367 150.329 304.728 152.69 304.728 155.599C304.728 158.508 302.367 160.869 299.458 160.869Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M273.078 125.841H329.342L337.451 106.529H273.078V125.841Z",
    fill: "#0099FA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M273 102.673L342.442 93.1038L350.936 72.3961L273 83.278V102.673Z",
    fill: "#0099FA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M273 79.4668L357.328 58.0061L366.832 34.9292L273 59.4478V79.4668Z",
    fill: "#0099FA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M383 6H400C406.627 6 412 11.3726 412 18V35H383V6Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M222 18C222 11.3726 227.373 6 234 6H251V35H222V18Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M383 167H412V184C412 190.627 406.627 196 400 196H383V167Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M222 167H251V196H234C227.373 196 222 190.627 222 184V167Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M398.12 20.374L400.5 24H399.226L397.504 21.2L395.726 24H394.508L396.888 20.36L394.648 16.888H395.922L397.532 19.548L399.156 16.888H400.416L398.12 20.374Z",
    fill: "#A9AEB4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M237.12 20.374L239.5 24H238.226L236.504 21.2L234.726 24H233.508L235.888 20.36L233.648 16.888H234.922L236.532 19.548L238.156 16.888H239.416L237.12 20.374Z",
    fill: "#A9AEB4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M398.12 181.374L400.5 185H399.226L397.504 182.2L395.726 185H394.508L396.888 181.36L394.648 177.888H395.922L397.532 180.548L399.156 177.888H400.416L398.12 181.374Z",
    fill: "#A9AEB4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M237.12 181.374L239.5 185H238.226L236.504 182.2L234.726 185H233.508L235.888 181.36L233.648 177.888H234.922L236.532 180.548L238.156 177.888H239.416L237.12 181.374Z",
    fill: "#A9AEB4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 166,
    width: 190,
    height: 1,
    fill: "#888B8D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 6,
    width: 190,
    height: 0.999992,
    transform: "rotate(90 252 6)",
    fill: "#888B8D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 34,
    width: 190,
    height: 1,
    fill: "#888B8D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 6,
    width: 190,
    height: 0.999992,
    transform: "rotate(90 384 6)",
    fill: "#888B8D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2755_30560",
    x: 0,
    y: 0,
    width: 214,
    height: 214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2755_30560"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2755_30560",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertical);
export default __webpack_public_path__ + "static/media/Vertical.a9b4e384f1de51f4b03af8c6c7472943.svg";
export { ForwardRef as ReactComponent };